var React = require('react');

function HeartFilled (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon Container"},React.createElement("path",{"id":"Union","d":"M16.323 4C17.7744 4.00089 19.2283 4.56583 20.3365 5.69482C21.4464 6.82559 22.0009 8.30689 22 9.78552C21.9991 11.2641 21.4446 12.7454 20.3365 13.8744L12.6169 21.7391C12.2764 22.087 11.7236 22.087 11.3822 21.7391L3.66266 13.8744C2.55451 12.7454 2 11.2633 2 9.78463C2 8.306 2.55451 6.82381 3.66266 5.69482C4.77082 4.56583 6.22565 4.00089 7.67698 4.00089C9.12832 4.00089 10.5832 4.56583 11.6913 5.69482L11.9996 6.00887L12.3087 5.69304C13.4177 4.56405 14.8717 3.99911 16.323 4Z","fill":"#625D52"})));
}

HeartFilled.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = HeartFilled;

HeartFilled.default = HeartFilled;
